module.exports = __webpack_public_path__ + "img/android-icon.d0b11a16.png";